import Image from 'next/future/image';
import BellFillIcon from '@/public/icons/account/bell-fill.svg';

export default function CustomerModalHeader(props: { header: string }) {
  return (
    <div
      className="mb-4 flex items-center rounded-md bg-[#F5FFFF] p-4 text-sm text-[#497C7D] shadow-sm"
      role="alert"
    >
      <div className="mr-5 flex h-[20px] w-[20px] items-center justify-center">
        <span className="h-[20px] w-[20px]">
          <Image
            height={20}
            width={20}
            priority
            alt="Wishlist"
            src={BellFillIcon}
            className="mr-4"
          />
        </span>
      </div>
      <div className="text-left">{props.header}</div>
    </div>
  );
}
